<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-col cols="12" sm="12">
      <v-card class="box">
        <v-col cols="12" sm="12">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Offer Assessment Scheme </strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
              <v-autocomplete dense required outlined rounded color="#0F2027" v-model="assessment_scheme"
                :items="assessment_scheme_list" item-text="name" item-value="id" label="Assessment Scheme"
                persistent-hint hint="Please select assessment scheme" />
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
              <v-autocomplete dense required outlined rounded color="#0F2027" v-model="ay" :items="ay_list"
                item-text="ay" item-value="id" label="Academic Year" persistent-hint
                hint="Please select academic year" />
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
              <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                item-text="name" item-value="id" label="Semester" persistent-hint hint="Please select semester" />
            </v-col>
          </v-row>
          <v-row>
            <!--  -->
            <v-col cols="12" sm="4" md="4" class="pt-6 m-0" v-if="passing_percentage_flag">
              <v-text-field v-model="passing_percentage" persistent-hint hint="Please Enter Passing Percentage"
                label="Passing Percentage" outlined rounded dense></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn dense outlined rounded class="button" @click="offerAssessmentScheme()">Offer</v-btn>
            <v-col sm="2" >
                    <v-btn class="mt-6 button" @click="copyDialog = true">Copy from Previous AY</v-btn>
                </v-col>
          </v-row>

          <v-row class="p-0 m-0" v-if="assessment_offer_list.length > 0">
            <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
            <v-col class="p-0 m-0" cols="12" sm="6" md="6">
              <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table"
                single-line hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-data-table v-if="assessment_offer_list.length > 0" dense :headers="headers" :items="bookList1"
            @current-items="getFiltered" :search="search" class="elevation-1 mytable">
            <template v-slot:item.passing_percentage="{ item }">
              <div class="d-flex align-center justify-center">
                <span class="mr-2">{{ item.passing_percentage }}</span>
                <v-avatar size="28" class="ma-0" color="#f5f5f5">
                  <v-icon small @click="openpassingdialog(item)" class="clickable-icon">
                    mdi-pencil
                  </v-icon>
                </v-avatar>
              </div>
            </template>
            <template v-slot:item.options="{ item }">
              <v-row>
                <v-switch v-model="item.isactive" class="p-0" color="#0F2027" @change="isactive(item.id)"></v-switch>
              </v-row>
            </template>
            <template v-slot:top class="pb-5">
              <v-row justify="center" align="center">
                <tr class="t-row">
                  <div>
                    <th>
                      <v-row>
                        <span v-for="header in headers" :key="header.text">
                          <span v-if="filters.hasOwnProperty(header.value)">
                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                              color="#0F2027" :label="header.text" multiple clearable
                              :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                          </span>
                        </span>
                      </v-row>
                    </th>
                  </div>
                </tr>
              </v-row>
            </template>
          </v-data-table>

        </v-col>
      </v-card>
      <v-dialog v-model="passing_dialog" max-width="800px">
        <v-card>
       <br>
            <v-card class="box">
              <v-row dense justify="center">
                <!--  -->
                <v-col cols="12" sm="4" md="4" class="pt-6 m-0" v-if="passing_percentage_flag">
                  <v-text-field v-model="edit_passing_percentage" persistent-hint hint="Please Enter Passing Percentage"
                    label="Passing Percentage" outlined rounded dense></v-text-field>
                </v-col>
              </v-row>
            </v-card>
         
          <v-row dense justify="center">
            <v-btn class="button" @click="editpassingpercentage()">Update</v-btn>
            <v-btn class="button" @click="passing_dialog = false">Close</v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="copyDialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Copy from Previous Academic Year
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col sm="12">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="copy_from_ay" return-object
                        :items="ay_list" item-text="ay" item-value="id" label="Copy From" outlined
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>

                <v-col sm="12">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="copy_to_ay" return-object
                        :items="ay_list" item-text="ay" item-value="id" label="Copy To" outlined
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer> </v-spacer>                    
                    <v-btn color="primary" @click="copyAssesmentScheme">Copy</v-btn>
                    <v-btn color="primary" text @click="copyDialog = false" outlined>
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-col>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      copyDialog: false,
      copy_from_ay: null,
      copy_to_ay: null,
      snackbar_msg: null,
      snackbar: false,
      color: "",
      ay_list: [],
      ay: null,
      assessment_scheme_list: [],
      assessment_scheme: null,
      assessment_offer_list: [],
      semester_list: [],
      sem: null,
      search: null,
      passing_percentage_flag: false,
      passing_dialog: false,
      edit_assessment_offer_scheme: "",
      edit_passing_percentage: "",

      filterArr: [],
      filters: {
        academicyear: [],
        semester: [],
      },
      headers: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Assessment Scheme",
          align: "left",
          sortable: false,
          value: "assessmentscheme",
        },
        {
          text: "Academic Year",
          align: "left",
          sortable: false,
          value: "academicyear",
        },
        {
          text: "Semester",
          align: "left",
          sortable: false,
          value: "semester",
        },
       
        {
          text: "Isactive",
          align: "left",
          sortable: false,
          value: "options",
        },
      ],
    };
  },
  computed: {
    bookList1() {
      return this.assessment_offer_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    openpassingdialog(item) { 
      this.passing_dialog = true;
      this.edit_assessment_offer_scheme=item.id,
        this.edit_passing_percentage = item.passing_percentage
   
    },
    editpassingpercentage() {
      const formData = {
        assessment_offer_scheme_id: this.edit_assessment_offer_scheme,
        passing_percentage: this.edit_passing_percentage,
      };
      axios
        .post("/examination/editPassingPercentage", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Passing Percentage Updated Successfully"
            );
            this.passing_dialog = false;
            this.onload();
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          //stop loader
          this.passing_dialog = false;
        });
    },

    copyAssesmentScheme() {
      const formData = {
        copy_to_ay: this.copy_to_ay.id,
        copy_from_ay: this.copy_from_ay.id,
      };
      axios
        .post("/examination/copyAssesmentScheme", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Assesment Offering copied Successfully"
            );
            this.copyDialog = false;
            this.onload();
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          //stop loader
          this.copyDialog = false;
        });
    },

    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.assessment_offer_list.map((d) => d[val]);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    isactive(item) {
      const formData = {
        assessment_offer_scheme: item,
      };
      axios
        .post("/examination/isactiveScheme", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Offer Assessment Scheme Updated Successfully"
            );
            this.onload();
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },
    offerAssessmentScheme() {
      if (this.assessment_scheme == null) {
        this.showSnackbar("#b71c1c", "Please select Assessment Scheme!!...");
        return;
      }
      if (this.ay == null) {
        this.showSnackbar("#b71c1c", "Please select Academic Year!!...");
        return;
      }
      const formData = {
        assessment_scheme: this.assessment_scheme,
        ay: this.ay,
        sem: this.sem,
        passing_percentage: this.passing_percentage,
      };
      console.log(formData);
      axios
        .post("/examination/offerScheme", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            if (res.data.flag == "NEW") {
              this.showSnackbar(
                "#4caf50",
                "Assessment Scheme Offered  Successfully"
              );
              this.onload();
            } else if (res.data.flag == "Exist") {
              this.showSnackbar(
                "#b71c1c",
                "Assessment Scheme  Already Offered!!..."
              );
              this.onload();
            }
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.assessment_scheme = null;
          this.ay = null;
          this.sem = null;
          this.passing_percentage = null;
        });
    },
    onload() {
      axios
        .post("/examination/offerAssessmentScheme")
        .then((res) => {
          this.assessment_scheme_list = res.data.assessment_scheme_list;
          this.ay_list = res.data.ay_list;
          this.semester_list = res.data.semester_list;
          this.assessment_offer_list = res.data.assessment_offer_list;
          this.passing_percentage_flag = res.data.passing_percentage_flag;

          const passingIndex = this.headers.findIndex(h => h.value === "passing_percentage");

          if (this.passing_percentage_flag === true) {
            if (passingIndex === -1) {
              this.headers.splice(3, 0, {
                text: "Passing Percentage",
                value: "passing_percentage",
                sortable: true,
                align: "center",
              });
            }
          } else {
            if (passingIndex !== -1) {
              this.headers.splice(passingIndex, 1);
            }
          }
        })
        .catch((error) => {
          alert("Something went wrong!!!");
        });
    }
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.box {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
  border: 2px solid #0f2027 !important;
}
.toolbar {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white;
}
.button {
  border: 2px solid #0f2027 !important;
  color: #0f2027;
  background: transparent !important;
  border-radius: 50px;
  margin: 0.5rem !important;
}
.button:hover {
  color: white;
  background: #0f2027 !important;
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
</style>
